<div>
  <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.items.update_an_item' | translate }}"
                    [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

  <div class="tab-container">
    <div class="waiver-tab-container">
      <div class="waiver-tab"
           [ngClass]="{'selected': showItemDetails}" (click)="showSteps('itemDetails')">
        <div>{{'bikeshop.modal.shared.bike.button.edit_bike_details' | translate }}</div>
      </div>
      <div class="waiver-tab" *ngIf="refreshedItem"
           [ngClass]="{'selected': showServiceHistory}" (click)="showSteps('serviceHistory')">
        <div>{{'bikeshop.rentals.products.service_history_title' | translate }}</div>
      </div>
      <div class="waiver-tab" *ngIf="partnerData.AllowItemTransfers && refreshedItem"
           [ngClass]="{'selected': showTransferItems}" (click)="showSteps('transferItems')">
        <div>{{ 'customer.item.edit_item.transfer' |  translate  }}</div>
      </div>
    </div>
  </div>

  <br />
  <div *ngIf="showItemDetails">

    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="item.manufacturer" label="{{'general.headers.manufacturer' | translate}}*"
                   [autofocus]="true"></hub-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="item.model" label="{{'general.headers.model' | translate}}*"></hub-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control" *ngIf="partnerType !== 'clothing'">
        <hub-input [(ngModel)]="item.modelYear" label="{{'general.headers.year' | translate}}"></hub-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="item.bikeSize"
                   label="{{'bikeshop.rentals.products.size' | translate}}"></hub-input>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input *ngIf="partnerTypeID!==11 && partnerTypeID!==2" [(ngModel)]="item.colour" label="{{'bikeshop.modal.shared.bike.color' | translate}}"></hub-input>
        <hub-text-area *ngIf="partnerTypeID===11 || partnerTypeID===2" [(ngModel)]="item.colour" label="{{'bikeshop.modal.shared.bike.color' | translate}}"></hub-text-area>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 input-control">
        <hub-input [(ngModel)]="item.serialNo"
                   label="{{'bikeshop.rentals.products.serial_number' | translate}}"></hub-input>
      </div>
    </div>
  
    <div class="row" *ngIf="partnerType === 'bicycle'">
      <div class="col-lg-12 input-control">
        <hub-dropdown #typeDropdown [options]="itemTypes" [(ngModel)]="item.typeID"
                      label="{{'general.headers.type' | translate}}"></hub-dropdown>
      </div>
    </div>


  </div>

  <div *ngIf="showTransferItems">
    <app-item-transfer  [bike]="refreshedItem" [user]="this.jobcard.customer" (completed)="setCompleted($event)"></app-item-transfer>
  </div>

  <div *ngIf="showServiceHistory">
    <app-item-service-history  [bike]="refreshedItem"></app-item-service-history>
  </div>


</div>

<div class="modal-footer-container" *ngIf="showItemDetails">

  <div class="button-container">

    <div>
      <hub-button *ngIf="jobcard.id"
                  [text]="'bikeshop.modal.update_job_card.job_card.select_different_item' | translate" [style]="'primary'"
                  [disabled]="updating" [loading]="updating" (buttonClick)="selectDifferentItem()"
                  [size]="'xl'"></hub-button>
    </div>
    <hub-button [text]="'bikeshop.general.update' | translate" [style]="'secondary'"
                [disabled]="!isValidItem() || updating" [loading]="updating" (buttonClick)="updateItem()"
                [size]="'xl'"></hub-button>
  </div>
  <div class="short-cut-container">
    <div>
      {{'bikeshop.workshop.jobcard.quote.to_navigate' | translate}}
    </div>
    <div>
      <span>
        <daz-icon [name]="'enter'" [size]="'18px'"
                  [color]="'#6B728C'"></daz-icon>
      </span>{{
'bikeshop.workshop.jobcard.quote.to_save_and_close' |
            translate
      }}
    </div>
  </div>
</div>

